var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.missingSamples),function(missingSample){return _c('missing-sample-item',{key:missingSample.id,attrs:{"data":missingSample}})}),_c('div',{staticClass:"cleaner"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }